import { KIND, SIZE } from 'baseui/button'
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from 'baseui/modal'
import ModalExportLogsTable from './Bones/ModalExportLogsTable/ModalExportLogsTable'
import { Upload } from 'baseui/icon'
import ActionTile from '@/containers/SubscriptionFormPageNew/Components/shared/ActionTile/ActionTile'
import useExportLogs from './useExportLogs'

const ExportLogs = () => {
  const { t, isAdmin, isOpen, logs, closeModal, fetchSubscriptionLogs } = useExportLogs()

  if (isAdmin === false) {
    return ''
  }

  return (
    <>
      <ActionTile
        id='export-log-save-button'
        label={t('subscriptionTools:tools.export_logs_button')}
        icon={<Upload size={22} />}
        onClick={fetchSubscriptionLogs}
      />

      <Modal
        onClose={closeModal}
        isOpen={isOpen}
        size={SIZE.default}
        overrides={{
          Dialog: {
            style: {
              width: '80vw',
            },
          },
        }}
      >
        <ModalHeader>{t('subscriptionForm:subscription_actions_module.export_logs.modal_header')}</ModalHeader>
        <ModalBody style={{ flex: '1 1 0' }}>
          <ModalExportLogsTable data={logs} />
        </ModalBody>
        <ModalFooter>
          <ModalButton kind={KIND.primary} onClick={closeModal}>
            {t('subscriptionForm:subscription_actions_module.export_logs.modal_close_button')}
          </ModalButton>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default ExportLogs
